import { render, staticRenderFns } from "./CustomerInquiryList.vue?vue&type=template&id=61178158&"
import script from "./CustomerInquiryList.vue?vue&type=script&lang=js&"
export * from "./CustomerInquiryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports